import { IYearMonth } from '../date';

/**
 * 内示遍歴テーブルのサービス
 */
export class ForecastTimelineService {
  /**
   * 内示遍歴テーブルの項目の種類を取得する
   * @param verticalYearMonth - 縦軸の年月
   * @param horizontalYearMonth - 横軸の年月
   */
  public static getTableCellType = (verticalYearMonth: IYearMonth, horizontalYearMonth: IYearMonth): 'forecast' | 'salesResult' => {
    if (verticalYearMonth.year === horizontalYearMonth.year && verticalYearMonth.month === horizontalYearMonth.month) {
      return 'salesResult';
    }
    return 'forecast';
  };
}
